// extracted by mini-css-extract-plugin
module.exports = {"logotype":"styles-module--logotype--1t3Ys","logotypeStatic":"styles-module--logotype-static--34ApO"};